export const CREATE_ICEPACK_FILLED = 'icepacks-filled-modal/CREATE_ICEPACK_FILLED';
export const createIcepackFilledAction = payload => ({
	type: CREATE_ICEPACK_FILLED,
	payload,
});

export const SET_IS_ICEPACK_FILLED_CREATING = 'icepacks-filled-modal/SET_IS_ICEPACK_FILLED_CREATING';
export const setIsIcepackFilledCreatingAction = payload => ({
	type: SET_IS_ICEPACK_FILLED_CREATING,
	payload,
});

export const GET_ICEPACKS = 'icepacks-filled-modal/GET_ICEPACKS';
export const getIcepacksAction = () => ({
	type: GET_ICEPACKS,
});

export const SET_ICEPACKS = 'icepacks-filled-modal/SET_ICEPACKS';
export const setIcepacksAction = payload => ({
	type: SET_ICEPACKS,
	payload,
});

export const SET_IS_ICEPACKS_LOADING = 'icepacks-filled-modal/SET_IS_ICEPACKS_LOADING';
export const setIsIcepacksLoadingAction = payload => ({
	type: SET_IS_ICEPACKS_LOADING,
	payload,
});

export const GET_ICEPACKS_FILLERS = 'icepacks-filled-modal/GET_ICEPACKS_FILLERS';
export const getIcepacksFillersAction = () => ({
	type: GET_ICEPACKS_FILLERS,
});

export const SET_ICEPACKS_FILLERS = 'icepacks-filled-modal/SET_ICEPACKS_FILLERS';
export const setIcepacksFillersAction = payload => ({
	type: SET_ICEPACKS_FILLERS,
	payload,
});

export const SET_IS_ICEPACKS_FILLERS_LOADING = 'icepacks-filled-modal/SET_IS_ICEPACKS_FILLERS_LOADING';
export const setIsIcepacksFillersLoadingAction = payload => ({
	type: SET_IS_ICEPACKS_FILLERS_LOADING,
	payload,
});

export const GET_ICEPACKS_STATES = 'icepacks-filled-modal/GET_ICEPACKS_STATES';
export const getIcepacksStatesAction = () => ({
	type: GET_ICEPACKS_STATES,
});

export const SET_ICEPACKS_STATES = 'icepacks-filled-modal/SET_ICEPACKS_STATES';
export const setIcepacksStatesAction = payload => ({
	type: SET_ICEPACKS_STATES,
	payload,
});

export const SET_IS_ICEPACKS_STATES_LOADING = 'icepacks-filled-modal/SET_IS_ICEPACKS_STATES_LOADING';
export const setIsIcepacksStatesLoadingAction = payload => ({
	type: SET_IS_ICEPACKS_STATES_LOADING,
	payload,
});

export const GET_MODES = 'icepacks-filled-modal/GET_MODES';
export const getModesAction = () => ({
	type: GET_MODES,
});

export const SET_MODES = 'icepacks-filled-modal/SET_MODES';
export const setModesAction = payload => ({
	type: SET_MODES,
	payload,
});

export const SET_IS_MODES_LOADING = 'icepacks-filled-modal/SET_IS_MODES_LOADING';
export const setIsModesLoadingAction = payload => ({
	type: SET_IS_MODES_LOADING,
	payload,
});

export const GET_ICEPACK_FILLED_INFO = 'icepacks-filled-modal/GET_ICEPACK_FILLED_INFO';
export const getIcepackFilledInfoAction = payload => ({
	type: GET_ICEPACK_FILLED_INFO,
	payload,
});

export const SET_ICEPACK_FILLED_INFO = 'icepacks-filled-modal/SET_ICEPACK_FILLED_INFO';
export const setIcepackFilledInfoAction = payload => ({
	type: SET_ICEPACK_FILLED_INFO,
	payload,
});

export const SET_IS_ICEPACK_FILLED_INFO_LOADING = 'icepacks-filled-modal/SET_IS_ICEPACK_FILLED_INFO_LOADING';
export const setIsIcepackFilledInfoLoadingAction = payload => ({
	type: SET_IS_ICEPACK_FILLED_INFO_LOADING,
	payload,
});

export const UPDATE_ICEPACK_FILLED = 'icepacks-filled-modal/UPDATE_ICEPACK_FILLED';
export const updateIcepackFilledAction = payload => ({
	type: UPDATE_ICEPACK_FILLED,
	payload,
});

export const SET_IS_ICEPACK_FILLED_UPDATING = 'icepacks-filled-modal/SET_IS_ICEPACK_FILLED_UPDATING';
export const setIsIcepackFilledUpdatingAction = payload => ({
	type: SET_IS_ICEPACK_FILLED_UPDATING,
	payload,
});

export const DELETE_ICEPACK_FILLED = 'icepacks-filled-modal/DELETE_ICEPACK_FILLED';
export const deleteIcepackFilledAction = payload => ({
	type: DELETE_ICEPACK_FILLED,
	payload,
});

export const SET_IS_ICEPACK_FILLED_DELETING = 'icepacks-filled-modal/SET_IS_ICEPACK_FILLED_DELETING';
export const setIsIcepackFilledDeletingAction = payload => ({
	type: SET_IS_ICEPACK_FILLED_DELETING,
	payload,
});

export const RESET_STATE = 'icepacks-filled-modal/RESET_STATE';
export const resetIcepackFilledModalAction = () => ({
	type: RESET_STATE,
});
